export const toCurrencies = currencies =>
  currencies.map(value => ({
    value: value.id,
    label: `${value.description} (${value.iso})`
  }))
